import { Button, ModalDialog, SelectField } from 'vetrf-ui';
import React, { useEffect, useState } from 'react';
import { FormContainer } from 'components/FormContainer';
import { AnimalSpeciesDictOption, SigningPersonDictOption } from 'api/dict/params';
import { dictApi } from 'api/dict';

type OrderingWithSignatureModalProps = {
  onClose: () => void;
  onSubmit: (signatory: SigningPersonDictOption) => void;
};

export const OrderingWithSignatureModal = ({
  onClose,
  onSubmit,
}: OrderingWithSignatureModalProps) => {
  const [options, setOptions] = useState<AnimalSpeciesDictOption[]>([]);

  const getOptions = async () => {
    const res = await dictApi.getSigningPerson();
    setOptions(res);
  };

  useEffect(() => {
    getOptions();
  }, []);

  return (
    <FormContainer onSubmit={(signingPerson) => onSubmit(signingPerson as SigningPersonDictOption)}>
      <ModalDialog
        header="Выберите подписанта"
        onClose={onClose}
        footer={
          <>
            <Button
              type="submit"
              color="success"
              iconColor="white"
              iconSize={100}
              size="sm"
              text="Сформировать"
            />
            <Button
              color="grey"
              iconColor="white"
              iconSize={100}
              onClick={onClose}
              size="sm"
              text="Отменить"
            />
          </>
        }
      >
        <SelectField
          labelText="Подписант"
          name="signingPerson"
          labelKey="fio"
          valueKey="id"
          required="Необходимо заполнить поле"
          options={options}
        />
      </ModalDialog>
    </FormContainer>
  );
};
